import React from 'react';

import Box from '@amzn/meridian/box';
import { type BoxProps } from '@amzn/meridian/box/box';
import Button from '@amzn/meridian/button';
import Card from '@amzn/meridian/card';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import _includes from 'lodash/includes';

// **** Types **** //

interface RestrictionItemBoxProps extends BoxProps {
  restrictionNumber: number;
  onRemoveRestriction: () => void;
  isDisabled: boolean;
}

// **** Components **** //

/**
 * Update the "selected task name list" when the selected name changes.
 */
const RestrictionItemBox = ({
  restrictionNumber,
  onRemoveRestriction,
  isDisabled,
  children,
  ...boxProps
}: RestrictionItemBoxProps) => {
  // So tests aren't broken
  const index = restrictionNumber - 1;

  return (
    <Card type="outline" disabled={true} {...boxProps}>
      {/* Header */}
      <Row alignmentHorizontal="justify">
        <Text type="h200" color="secondary">
          Restriction {restrictionNumber}
        </Text>
        {!isDisabled && (
          <Button
            type="link"
            onClick={onRemoveRestriction}
            data-cy={`new-jmr__remove-restriction__btn__${index}`}
            data-testid={`new-jmr__remove-restriction__btn__${index}`}
          >
            Remove
          </Button>
        )}
      </Row>
      <Box spacingInset="200" />

      {/* Body */}
      {children}
    </Card>
  );
};

// **** Export **** //

export default RestrictionItemBox;
